var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLojinhaHomeCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.2683,
    cy: 31.5541,
    rx: 32.2683,
    ry: 31.5541,
    fill: "#FF8C05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2581 16L25.2258 38.6667L15.7419 29.3333L11 34L25.2258 48L53 20.6667L48.2581 16Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLojinhaHomeCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lojinha-home-check.45b59e7a.svg";
export { ForwardRef as ReactComponent };